import React from "react";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import Header from "../components/generalComponents/Header";
import SingleOrder from "../components/orderHistory/SingleOrder";

export default function SingleOrderView() {
  return (
    <div className="pageWrapper">
      <Header title="Uw Order" needsLocation={false} />
      <div className="contentWrapper fadeInDelayed">
        <SingleOrder />
      </div>
      <BottomNavBar />
    </div>
  );
}
